import React, { useEffect, useState } from 'react';
import './index.scoped.scss';
import logo1 from '@@/assets/img/partners_section/1.png';
import logo2 from '@@/assets/img/partners_section/2.png';
import logo3 from '@@/assets/img/partners_section/3.png';
import logo4 from '@@/assets/img/partners_section/4.png';
import logo5 from '@@/assets/img/partners_section/5.png';
import logo6 from '@@/assets/img/partners_section/6.png';
import logo7 from '@@/assets/img/partners_section/7.png';
import logo8 from '@@/assets/img/partners_section/8.png';
import logo9 from '@@/assets/img/partners_section/9.png';
import logo10 from '@@/assets/img/partners_section/10.png';
import logo11 from '@@/assets/img/partners_section/11.png';
import logo12 from '@@/assets/img/partners_section/12.png';
import logo13 from '@@/assets/img/partners_section/13.png';
import logo14 from '@@/assets/img/partners_section/14.png';
import logo15 from '@@/assets/img/partners_section/15.png';
import logo16 from '@@/assets/img/partners_section/16.png';
import logo17 from '@@/assets/img/partners_section/17.png';
import logo18 from '@@/assets/img/partners_section/18.png';
import logo19 from '@@/assets/img/partners_section/19.png';
import logo20 from '@@/assets/img/partners_section/20.png';
import logo21 from '@@/assets/img/partners_section/21.png';
import logo22 from '@@/assets/img/partners_section/22.png';
import logo23 from '@@/assets/img/partners_section/23.png';
import logo24 from '@@/assets/img/partners_section/24.png';
import logo25 from '@@/assets/img/partners_section/25.png';
import logo26 from '@@/assets/img/partners_section/26.png';
import logo27 from '@@/assets/img/partners_section/27.png';
import logo28 from '@@/assets/img/partners_section/28.png';
import logo29 from '@@/assets/img/partners_section/29.png';
import logo30 from '@@/assets/img/partners_section/30.png';
import logo31 from '@@/assets/img/partners_section/31.png';
import logo32 from '@@/assets/img/partners_section/32.png';
import logo33 from '@@/assets/img/partners_section/33.png';
import logo34 from '@@/assets/img/partners_section/34.png';
import logo35 from '@@/assets/img/partners_section/35.png';
import logo36 from '@@/assets/img/partners_section/36.png';
import logo37 from '@@/assets/img/partners_section/37.png';

// 使用实际logo的组件
const PartnerLogo: React.FC<{ logo: string }> = ({ logo }) => (
    <div className="partner-logo">
        <img src={logo} alt="" />
    </div>
);

const PartnersSection: React.FC = () => {
    // 使用实际导入的logo图片
    const partnerLogos = [
        { logo: logo1 },
        { logo: logo2 },
        { logo: logo3 },
        { logo: logo4 },
        { logo: logo5 },
        { logo: logo6 },
        { logo: logo7 },
        { logo: logo8 },
        { logo: logo9 },
        { logo: logo10 },
        { logo: logo11 },
        { logo: logo12 },
        { logo: logo13 },
        { logo: logo14 },
        { logo: logo15 },
        { logo: logo16 },
        { logo: logo17 },
        { logo: logo18 },
        { logo: logo19 },
        { logo: logo20 },
        { logo: logo21 },
        { logo: logo37 },
        { logo: logo22 },
        { logo: logo23 },
        { logo: logo24 },
        { logo: logo25 },
        { logo: logo26 },
        { logo: logo27 },
        { logo: logo28 },
        { logo: logo29 },
        { logo: logo30 },
        { logo: logo31 },
        { logo: logo32 },
        { logo: logo33 },
        { logo: logo34 },
        { logo: logo35 },
        { logo: logo36 }
    ];

    // 使用Fisher-Yates洗牌算法随机打乱数组
    const shuffleArray = (array: any[]) => {
        const newArray = [...array];
        for (let i = newArray.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [newArray[i], newArray[j]] = [newArray[j], newArray[i]];
        }
        return newArray;
    };

    // 分配并打乱三行的logo
    const [rows, setRows] = useState<{ logo: string }[][]>([[], [], []]);

    useEffect(() => {
        // 克隆并打乱原始数组
        // const shuffled = shuffleArray([...partnerLogos]);
        const shuffled = [...partnerLogos];

        // 计算每行大致的logo数量
        const itemsPerRow = Math.ceil(shuffled.length / 4);

        // 分配到三行（确保每行至少有itemsPerRow个项目，如果不够我们会复制）
        const row1 = shuffled.slice(0, itemsPerRow);
        const row2 = shuffled.slice(itemsPerRow, itemsPerRow * 2);
        const row3 = shuffled.slice(itemsPerRow * 2, itemsPerRow * 3);
        const row4 = shuffled.slice(itemsPerRow * 3);

        // 确保每行有足够的元素（至少itemsPerRow * 2个，以便动画流畅）
        // 我们复制元素直到达到所需数量
        const ensureItemCount = (row: { logo: string }[], minCount: number): { logo: string }[] => {
            let result = [...row];
            while (result.length < minCount) {
                result = [...result, ...row];
            }
            return result.slice(0, minCount);
        };

        // 每行至少需要的元素数量，足够长以确保滚动动画无缝
        const minItemsPerRow = itemsPerRow * 4;

        setRows([ensureItemCount(row1, minItemsPerRow), ensureItemCount(row2, minItemsPerRow), ensureItemCount(row3, minItemsPerRow), ensureItemCount(row4, minItemsPerRow)]);
    }, []);

    return (
        <div className="partners-section-wrapper">
            <div className="partners-scroll-container">
                {rows.map((row, rowIndex) => (
                    <div key={rowIndex} className={`partners-row ${rowIndex % 2 === 0 ? 'scroll-right' : 'scroll-left'}`}>
                        <div className="partners-row-inner">
                            {row.map((item, logoIndex) => (
                                <PartnerLogo key={`${rowIndex}-${logoIndex}`} logo={item.logo} />
                            ))}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default PartnersSection;
